import { fetchOfferListFilters } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { EmptyObject } from 'lib/object/objectUtils'
import getOfferListKey from 'lib/offer/offerListKey'
import { LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE } from 'loyalty/constants/loyaltySearchFilters'
import getLoyaltyStayUpgradeBenefitView from 'loyalty/selectors/getLoyaltyStayUpgradeBenefitView'
import { useEffect, useMemo } from 'react'

export const emptyFilters: App.OfferListFilterOptions = {
  error: undefined,
  fetching: true,
  filterOrder: {
    amenities: {},
    holidayTypes: {},
  },
  filters: {
    amenities: {},
    bedrooms: {},
    campaigns: {},
    holidayTypes: {},
    offerTypes: {},
    propertyTypes: {},
    luxPlusFeatures: {},
    loyalty: {},
    agentHubFeatures: {},
    paymentOptions: {},
    total: 0,
  },
  orderedFilters: {
    amenities: [],
    holidayTypes: [],
  },
}

interface Options {
  disabled?: boolean

  /**
   * Whether to fetch the offer list or just return existing offer list
   */
  noFetch?: boolean
}

function useOfferListFilters(filters: App.OfferListFilters, options: Options = EmptyObject): App.OfferListFilterOptions {
  const key = getOfferListKey(filters)
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!options.disabled && !options.noFetch && !filters?.isStream) {
      dispatch(fetchOfferListFilters(filters))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, options])

  const listFilterOptions = useAppSelector(state => state.offer.offerListFilterOptions[key]) ?? emptyFilters

  const hasLoyaltyStayUpgradeBenefit = !!useAppSelector(getLoyaltyStayUpgradeBenefitView)?.availability

  const listFilters = useMemo(() => {
    if (!hasLoyaltyStayUpgradeBenefit) {
      const listFilterOptionsClone = structuredClone(listFilterOptions)
      delete listFilterOptionsClone.filters?.loyalty[LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE]
      return listFilterOptionsClone
    }

    return listFilterOptions
  }, [listFilterOptions, hasLoyaltyStayUpgradeBenefit])

  return listFilters
}

export default useOfferListFilters
